import React from "react";
import '../../styles/Fuel.css';

const FuelCard = ({ title, subtitle, tabs = [], items = [], checkedIcon = null }) => {
    return (
        <div className="fuel_card_container">
            <div className="fuel_card_header">
                <div className="fuel_card_title_group">
                    <h4>{title} <span>{checkedIcon}</span></h4>
                    {subtitle && <p>{subtitle}</p>}
                </div>
                {tabs.length > 0 && (
                    <div className="fuel_card_tabs">
                        {tabs.map((tab, index) => (
                            <button
                                key={index}
                                className={`fuel_card_tab ${tab.active ? 'active' : ''}`}
                                onClick={tab.onClick}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </div>
                )}
            </div>

            <div className="fuel_card_content_box">
                {items.map((item, index) => (
                    <div key={index} className="fuel_card_row">
                        <div className="fuel_card_row_left">
                            <span className="fuel_row_icon">{item.icon}</span>
                            <span className="fuel_row_label">
                                {item.label}
                                {item.unit && <span className="fuel_row_unit"> ({item.unit})</span>}
                            </span>
                        </div>
                        <div className={`fuel_card_row_right ${item.valueColor ? item.valueColor : ''} ${item.isHighlight ? 'highlight_pill' : ''}`}>
                            <span className={`fuel_row_value ${item.valueColor ? item.valueColor : ''}`}>
                                {item.value}
                            </span>
                            {item.subValue && <span className="fuel_row_subvalue">{item.subValue}</span>}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FuelCard;